import React from 'react';
import { Box, Typography } from '@mui/material';
import { useElapsedTime } from '../hooks/useElapsedTime';

interface Vyjezd2026CasovkaOverlayProps {
    casVyhlaseni: string;
    casVyjezdMinuty: number;  // povinny - zadny interni query (K0.5)
}

export const Vyjezd2026CasovkaOverlay: React.FC<Vyjezd2026CasovkaOverlayProps> = ({
    casVyhlaseni, casVyjezdMinuty,
}) => {
    const { elapsed, formatted, shouldBlink } = useElapsedTime(casVyhlaseni, casVyjezdMinuty);

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                zIndex: 1000,
                bgcolor: 'rgba(0, 0, 0, 0.65)',
                color: '#ffffff',
                borderRadius: 2,
                px: 2,
                py: 1,
                ...(shouldBlink && {
                    animation: 'blink 1s ease-in-out infinite',
                    '@keyframes blink': {
                        '0%, 100%': { opacity: 1 },
                        '50%': { opacity: 0.3 },
                    },
                }),
            }}
        >
            <Typography
                sx={{
                    fontWeight: 'bold',
                    fontSize: 'var(--dashboard-vyjezd-time-size, 4rem)',
                    lineHeight: 1,
                    color: elapsed < 0 ? '#7CFC00' : '#FF6B6B',
                    // Tabular numerals — všechny číslice mají stejnou šířku, takže layout
                    // neposkakuje s každou změnou sekundy. Bez tohoto se "-" sign a kratší
                    // číslice (1) působí jako nesymetrický odsazení proti pravému okraji.
                    fontVariantNumeric: 'tabular-nums',
                    fontFeatureSettings: '"tnum"',
                    textAlign: 'center',
                    fontFamily: 'monospace',
                }}
            >
                {formatted}
            </Typography>
        </Box>
    );
};
